module.exports = __webpack_public_path__ + "img/bg_bata.6cc5fd82.png";